import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { SelectField } from '../../01_atoms/FormElements';
import { DEFAULT_CURRENCY, formatAmount } from '../../../utils/currency';
import { getFundraisingCosts } from '../../../utils/donationForm';

import s from './index.module.scss';

const FundraisingCostsVariantB = () => {
  const heading = 'Would you like to help cover fundraising costs?';
  const description =
    'By contributing to costs such as bank fees and service providers, more of your donation will go directly to supporting our mission.';
  const formState = useFormState();
  const form = useForm();

  const setValue = form.mutators.setValue;
  const fundraisingCostsAmount = getFundraisingCosts(formState.values.amount, '5%');

  // Recalculate transaction fee every time when render the component.
  const options = [
    {
      value: '2%',
      label: `${formatAmount(
        DEFAULT_CURRENCY,
        getFundraisingCosts(formState.values.amount, '2%'),
      )} (2%)`,
    },
    {
      value: '5%',
      label: `${formatAmount(
        DEFAULT_CURRENCY,
        getFundraisingCosts(formState.values.amount, '5%'),
      )} (5%)`,
    },
    {
      value: '7%',
      label: `${formatAmount(
        DEFAULT_CURRENCY,
        getFundraisingCosts(formState.values.amount, '7%'),
      )} (7%)`,
    },
    {
      value: 'without_fee',
      label: "I'd prefer not to contribute",
    },
  ];

  useEffect(() => {
    // Set the 5% option by default. It couldn't be done by the initial_state,
    // property, because we don't know amount by that time.
    const selectedOption = options.find(
      (item) => item.value === formState.values.fundraising_costs.value,
    );

    if (!selectedOption) {
      // Set 5% as a default option.
      setValue('fundraisingCostsApplied', true);
      setValue('fundraisingCostsAmount', fundraisingCostsAmount);
      setValue('totalAmount', Number(formState.values.amount) + Number(fundraisingCostsAmount));
      setValue('fundraising_costs', {
        value: '5%',
        label: `${formatAmount(DEFAULT_CURRENCY, fundraisingCostsAmount)} (5%)`,
      });
    } else {
      setValue('fundraising_costs', selectedOption);
    }
  }, []);

  return (
    <div className={s['fundraising-costs-variant-b']}>
      <div className={s['fundraising-costs-variant-b__heading']}>{heading}</div>
      <div className={s['fundraising-costs-variant-b__description']}>{description}</div>
      <SelectField
        name="fundraising_costs"
        data-analytics="fundraising-costs-drop-down"
        options={options}
        isRequired
        autoFill={false}
        onOptionSelect={(option) => {
          if (option.value === 'without_fee') {
            if (formState.values.fundraisingCostsApplied) {
              setValue('fundraisingCostsApplied', false);
            }
            setValue('fundraisingCostsAmount', 0);
          } else {
            if (!formState.values.fundraisingCostsApplied) {
              setValue('fundraisingCostsApplied', true);
            }

            const fundraisingCostsAmount = getFundraisingCosts(
              formState.values.amount,
              option.value,
            );
            // Update fundraising costs and total amount.
            setValue('fundraisingCostsAmount', fundraisingCostsAmount);
            setValue(
              'totalAmount',
              Number(formState.values.amount) + Number(fundraisingCostsAmount),
            );
          }
        }}
      />
    </div>
  );
};

export default FundraisingCostsVariantB;
